import ApiClient from "@/api/ApiClient.ts";

const DELIVERY_ZONES_PATH = "deliveryZones";

/**
 * Get delivery zones for all centrals
 *
 * @param wgId the workgroup id
 */
export async function getDeliveryZones(wgId) {
  if (!wgId) return [];
  const params = {
    wgId, // suspecting this is wrong
    idWg: wgId,
  };
  return await ApiClient()
    .get(DELIVERY_ZONES_PATH, { params })
    .then((response) => response.data);
}

/**
 * Create delivery zone
 *
 * @param wgId the workgroup id
 * @param centralId the central id
 * @param data the delivery zone data
 */
export async function createDeliveryZone(wgId, centralId, data) {
  const params = {
    idWg: wgId,
    idCentral: centralId,
  };
  return await ApiClient()
    .post(DELIVERY_ZONES_PATH, data, { params })
    .then((response) => response.data);
}

/**
 * Update delivery zone
 *
 * @param wgId the workgroup id
 * @param centralId the central id
 * @param deliveryZoneId the delivery zone id
 * @param data the delivery zone data
 */
export async function updateDeliveryZone(wgId, centralId, deliveryZoneId, data) {
  const params = {
    idWg: wgId,
    idCentral: centralId,
    idDeliveryZone: deliveryZoneId,
  };
  return await ApiClient()
    .put(DELIVERY_ZONES_PATH, data, { params })
    .then((response) => response.data);
}

/**
 * Delete a delivery zone
 *
 * @param wgId the workgroup id
 * @param centralId the central id
 * @param deliveryZoneId the delivery zone id
 */
export async function deleteDeliveryZone(wgId, centralId, deliveryZoneId) {
  const params = {
    idWg: wgId,
    idCentral: centralId,
    idDeliveryZone: deliveryZoneId,
  };
  return await ApiClient()
    .delete(DELIVERY_ZONES_PATH, { params })
    .then((response) => response.data);
}
